class FavoriteButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.productId = this.dataset.productId;
    this.setupListeners();
    this.checkStatus();
  }

  setupListeners() {
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleFavorite();
    });
  }

  getFavorites() {
    return JSON.parse(localStorage.getItem('panspaza_favorites') || '[]');
  }

  checkStatus() {
    const favorites = this.getFavorites();
    if (favorites.includes(this.productId)) {
      this.button.classList.add('is-active');
    }
  }

  toggleFavorite() {
    let favorites = this.getFavorites();
    const index = favorites.indexOf(this.productId);
    
    if (index > -1) {
      favorites.splice(index, 1);
      this.button.classList.remove('is-active');
    } else {
      favorites.push(this.productId);
      this.button.classList.add('is-active');
    }
    
    localStorage.setItem('panspaza_favorites', JSON.stringify(favorites));
  }
}

customElements.define('favorite-button', FavoriteButton);
